export default {
    profileReferenceChart: {
        title: 'Fig A · Individual product profiles',
        subtitle: 'Reference — each profile shown alone',
        baseLabel: 'BASE (1.0 MW flat)',
        peakLabel: 'PEAK (2.5 MW · 08:00–20:00)',
        offPeakLabel: 'OFF_PEAK (0.8 MW · flanks)',
        ariaBase: 'BASE profile: flat 1 MW across all 96 fifteen-minute buckets',
        ariaPeak: 'PEAK profile: 2.5 MW during 08:00 to 20:00, zero outside',
        ariaOffPeak:
            'OFF_PEAK profile: 0.8 MW during 00:00–08:00 and 20:00–24:00, zero during peak',
    },
}
